import {
    HttpEvent,
    HttpHandler,
    HttpRequest,
    HttpInterceptor
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Attaches the logged-in user's session id to every request hitting our PHP
 * backend (paths under /api). The session id is the same value stored in
 * localStorage as `loggedInMbId` and used by api.service.ts in postData;
 * the header makes it available without requiring every new endpoint to
 * remember to add it to the body.
 *
 * The backend's UserToken middleware looks for the session id in (in order):
 * query string, this header, parsed input, raw JSON body.
 */
@Injectable()
export class UserTokenInterceptor implements HttpInterceptor {
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (this.isOurApi(request.url)) {
            const uid = localStorage.getItem('loggedInMbId');
            if (uid) {
                request = request.clone({
                    setHeaders: { 'X-User-Token-Id': uid }
                });
            }
        }
        return next.handle(request);
    }

    private isOurApi(url: string): boolean {
        return /\/api(\/|$|\?)/.test(url);
    }
}
